import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AddEditPaymentMethod from './AddEditPaymentMethod'
import { Elements } from '@stripe/react-stripe-js'
import { getStripe } from '../../app/stripe';

export default function PaymentMethodsPage() {
    const stripePromise = getStripe();

    return (
        <Elements stripe={stripePromise}>
            <Routes>
                <Route path="/payment-method" element={<AddEditPaymentMethod />} />
            </Routes>
        </Elements>
    )
}